import { IconSprite } from "../../ui/IconSprite/IconSprite";

import { IconBox } from "./NoticeStatus.styled";

export const NoticeStatus = ({ status = true }) => (
  <IconBox status={status}>
    <IconSprite tag={status ? "confirm" : "minus"} width="32" height="32" />
  </IconBox>
);
